var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnlineBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 36,
    viewBox: "0 0 48 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47.9966,
    height: 36,
    rx: 8,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 46.9966,
    height: 35,
    rx: 7.5,
    stroke: "#040517",
    strokeOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9082 10.2424C27.1425 10.0081 27.5224 10.0081 27.7567 10.2424L30.4012 12.8869C30.5235 12.9968 30.6004 13.1561 30.6004 13.3334C30.6004 13.5114 30.5228 13.6714 30.3997 13.7813L27.7567 16.4242C27.5224 16.6586 27.1425 16.6586 26.9082 16.4242C26.6738 16.1899 26.6738 15.81 26.9082 15.5757L28.5505 13.9334H20.6671C20.1189 13.9334 19.5933 14.1511 19.2057 14.5387C18.8181 14.9263 18.6004 15.452 18.6004 16.0001V17.3334C18.6004 17.6648 18.3318 17.9334 18.0004 17.9334C17.669 17.9334 17.4004 17.6648 17.4004 17.3334V16.0001C17.4004 15.1337 17.7446 14.3028 18.3572 13.6902C18.9698 13.0776 19.8007 12.7334 20.6671 12.7334H28.5506L26.9082 11.0909C26.6738 10.8566 26.6738 10.4767 26.9082 10.2424ZM30.0004 18.0667C30.3318 18.0667 30.6004 18.3353 30.6004 18.6667V20C30.6004 20.8664 30.2562 21.6972 29.6436 22.3099C29.031 22.9225 28.2001 23.2667 27.3337 23.2667H19.449L21.0913 24.909C21.3256 25.1433 21.3256 25.5232 21.0913 25.7575C20.857 25.9918 20.4771 25.9918 20.2428 25.7575L17.582 23.0968C17.5562 23.0716 17.5326 23.0441 17.5115 23.0146C17.4416 22.9165 17.4004 22.7964 17.4004 22.6667C17.4004 22.5976 17.412 22.5313 17.4335 22.4696C17.4623 22.3866 17.5098 22.3086 17.5761 22.2423L20.2428 19.5756C20.4771 19.3413 20.857 19.3413 21.0913 19.5756C21.3256 19.81 21.3256 20.1899 21.0913 20.4242L19.4488 22.0667H27.3337C27.8818 22.0667 28.4075 21.8489 28.7951 21.4613C29.1827 21.0738 29.4004 20.5481 29.4004 20V18.6667C29.4004 18.3353 29.669 18.0667 30.0004 18.0667Z",
    fill: "#040517"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineBank);
export default __webpack_public_path__ + "static/media/onlineBank.bf9bdc9e99c113253b5e0616f0681393.svg";
export { ForwardRef as ReactComponent };